class UserPermissionHelper {
  static getAllRoles(userRoleItems, roleName, subRoleName) {
    // console.log("userRoleItems: ", userRoleItems)
    if (!userRoleItems || !Array.isArray(userRoleItems)) return null;

    const role = userRoleItems.find(
      (item) =>
        item.role_name === roleName && item.sub_role_name === subRoleName
    );
    return role
      ? [
          JSON.parse(role.all_roles).reduce((acc, item) => {
            acc[item.value] = item.enabled;
            return acc;
          }, {}),
        ]
      : null;
    //return role ? role.all_roles ?? null : null;
  }
}

export default UserPermissionHelper;
